import * as yup from "yup";

export const NPI_VALIDATION = yup.object().shape({
  npi: yup.string().required("Enter Entity Item Key"),
});

export const EDIT_FORM_VALIDATION_SCHEMA = yup.object().shape({
  primary: yup.array().of(
    yup.object().shape({
      fname: yup.string().nullable(),
      mname: yup.string().nullable(),
      lname: yup.string().nullable(),
      dob: yup.date().nullable(),
      gender: yup.string().nullable(),
      provider_type_desc: yup.string().nullable(),
      ssn: yup
        .string()
        .matches(/^[0-9]+$/, "Must be a number")
        .min(9, "Must be exactly 9 digits")
        .max(9, "Must be exactly 9 digits")
        .nullable(),
      medicaid_no: yup
        .string()
        .max(20, "Must not be more than 20 characters")
        .nullable(),
      medicare_no: yup
        .string()
        .max(15, "Must not be more than 15 characters")
        .nullable(),
      provider_type_code: yup
        .string()
        .max(10, "Must not be more than 10 characters")
        .nullable(),
      primary_specialty_desc: yup
        .string()
        .max(80, "Must not be more than 80 characters")
        .nullable(),
      secondary_specialty_desc: yup
        .string()
        .max(80, "Must not be more than 80 characters")
        .nullable(),
    })
  ),
  office: yup.array().of(
    yup.object().shape({
      office_name: yup.string().nullable(),
      addr1: yup.string().nullable(),
      addr2: yup.string().nullable(),
      tax_id: yup
        .string()
        .matches(/^[0-9]+$/, "Must be a number")
        .min(9, "Must be exactly 9 digits")
        .max(9, "Must be exactly 9 digits")
        .nullable(),
      is_primary: yup.string().nullable(),
    })
  ),
  board_certification: yup.array().of(
    yup.object().shape({
      issuer_name: yup.string().nullable(),
      spec_desc: yup
        .string()
        .max(80, "Must not be more than 80 characters")
        .nullable(),
      is_certified: yup.string().nullable(),
      initial_cred_date: yup.date().nullable(),
      expiration_date: yup.date().nullable(),
    })
  ),
  state_lic: yup.array().of(
    yup.object().shape({
      board_name: yup.string().nullable(),
      state: yup.string().nullable(),
      license_number: yup.string().nullable(),
      expiration_date: yup.date().nullable(),
      initial_cred_date: yup.date().nullable(),
    })
  ),
  dea: yup.array().of(
    yup.object().shape({
      state: yup.string().nullable(),
      cert_number: yup
        .string()
        .min(9, "Must be 9 characters")
        .max(9, "Must be 9 characters")
        .nullable(),
      expiration_date: yup.date().nullable(),
    })
  ),
  medicaid: yup.array().of(
    yup.object().shape({
      medicaid_no: yup.string().nullable(),
    })
  ),
  education: yup.array().of(
    yup.object().shape({
      school_name: yup.string().nullable(),
      edu_type_desc: yup
        .string()
        .max(80, "Must not be more than 80 characters")
        .nullable(),
      edu_category_desc: yup
        .string()
        .max(80, "Must not be more than 80 characters")
        .nullable(),
      addr1: yup.string().nullable(),
      addr2: yup.string().nullable(),
      attn: yup.string().nullable(),
      city: yup.string().nullable(),
      state: yup.string().nullable(),
      zip: yup.string().nullable(),
      ecfmg_id_code: yup.string().nullable(),
      start_date: yup.date().nullable(),
      end_date: yup.date().nullable(),
      ecfmg_effective_date: yup.date().nullable(),
    })
  ),
  hospital: yup.array().of(
    yup.object().shape({
      hospital_name: yup.string().nullable(),
      is_primary: yup.string().nullable(),
      is_restricted: yup.string().nullable(),
      privilege_type: yup.string().nullable(),
    })
  ),
  accreditation: yup.array().of(
    yup.object().shape({
      certificate_number: yup.string().nullable(),
      issuer_name: yup.string().nullable(),
      expiration_date: yup.date().nullable(),
      effective_date: yup.date().nullable(),
    })
  ),
  insurance: yup.array().of(
    yup.object().shape({
      issuer_name: yup.string().nullable(),
      policy_number: yup.string().nullable(),
      claim_limit: yup.number().nullable(),
      aggregate_limit: yup.number().nullable(),
      effective_date: yup.date().nullable(),
      expiration_date: yup.date().nullable(),
      retro_date: yup.date().nullable(),
    })
  ),
  work_history: yup.array().of(
    yup.object().shape({
      history_name: yup.string().nullable(),
      start_date: yup.date().nullable(),
      end_date: yup.date().nullable(),
    })
  ),
});

export const ADD_TEMPLATE_VALIDATION = yup.object().shape({
  name: yup.string().trim().required("Please enter a template name"),
  entity: yup.object().required("Please select an entity"),
  hierarchies: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().required("Please enter a hierarchy name"),
        fields: yup
          .array()
          .of(
            yup.object().shape({
              name: yup.string().trim().required("Please enter a field name"),
              type: yup.object().shape().required("Please select a field type"),
            })
          )
          .required("Please enter at-least one field"),
      })
    )
    .required("Please enter at-least one hierarchy "),
});

export const ADD_ASSOCIATION_TEMPLATE_VALIDATION = yup.object().shape({
  fromEntity: yup.object().nullable().required("Please select from entity"),
  toEntity: yup.object().nullable().required("Please select to entity"),
  fields: yup
    .array()
    .of(
      yup.object().shape({
        name: yup.string().trim().required("Please enter a field name"),
        type: yup.object().shape().required("Please select a field type"),
      })
    )
    .required("Please enter at-least one field"),
});

export const ADD_ASSOCIATION_VALIDATION = yup.object().shape({
  target_key: yup.object().required("Please select an target entity item"),
  association_type: yup
    .string()
    .trim()
    .required("Please enter an association type"),
  start_date: yup.date().required("Please select a date"),
  end_date: yup.date().required("Please select a date"),
});

export const ADD_ENTITY_VALIDATION = yup.object().shape({
  name: yup.string().trim().required("Please enter Entity name"),
  entity_key_name: yup.string().trim().required("Please enter Entity Key name"),
});
